import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  sectionContainer: {
    // Subsequent Sections
    '& + &': {
      paddingTop: theme.spacing(4),
    },
  },
}));

export default useStyles;
